
(function(){
 const root=window.Shopify?.routes?.root||'/';
 function route(scope){scope.querySelectorAll('a[href]').forEach(a=>{
   if(a.closest('[data-du-measured-section]'))return;
   let url;try{url=new URL(a.href,location.origin)}catch(_){return}
   if(url.origin!==location.origin)return;
   const text=a.textContent.trim(); const path=url.pathname.toLowerCase();
   const isTub=/tub/.test(path)&&!/tray/.test(path);
   const shop=/shop|find.*vehicle|find.*ute|see if we have|explore.*fit|match.up quiz|choose.*vehicle/i.test(text);
   const oldEntry=['dv-hilux-n90','dv-match'].includes(url.searchParams.get('view'));
   if(oldEntry || (shop && isTub) || /^(find my vehicle|find your vehicle|shop by vehicle|shop tubs|find my ute)$/i.test(text)){
     let product=url.searchParams.get('du_product');
     if(isTub) product=/wheel.arch/.test(path)?'arch':/slider/.test(path)?'slider':'drop-in';
     a.href=root+'collections/all?view=dv-vehicles'+(product?'&du_product='+encodeURIComponent(product):'');
     if(/n90/i.test(text))a.textContent='Find your vehicle →';
   }
 });}
 route(document);document.addEventListener('shopify:section:load',e=>route(e.target));
})();
